(() => {
  if (window.novaProductExperience) {
    window.novaProductExperience();
    return;
  }
  const instances = new WeakMap();
  const mobile = window.matchMedia("(max-width: 749px)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const initialize = (root) => {
    if (root.closest("quick-add-modal")) return;
    const bar = root.querySelector("[data-nova-purchase-bar]");
    const action = bar?.querySelector("[data-nova-purchase-action]");
    const form = root.querySelector('product-form form[data-type="add-to-cart-form"]');
    const current = instances.get(root);
    if (!bar || !action || !form || !window.IntersectionObserver) return;
    if (current?.bar === bar && current?.form === form) return;
    current?.dispose();
    let purchaseVisible = false;
    const update = () => {
      bar.hidden = !mobile.matches || purchaseVisible || !root.isConnected;
    };
    const observer = new IntersectionObserver((entries) => {
      purchaseVisible = entries.some((entry) => entry.isIntersecting);
      update();
    }, { threshold: 0.15 });
    observer.observe(form);
    const activate = (event) => {
      const area = root.querySelector('[id^="ProductInfo-"]');
      if (!area) return;
      event.preventDefault();
      area.scrollIntoView({ block: "start", behavior: reducedMotion.matches ? "auto" : "smooth" });
      const focusTarget = area.querySelector('variant-selects input[type="radio"]:checked, variant-selects select, input[name="quantity"], button[name="add"]');
      focusTarget?.focus({ preventScroll: true });
    };
    action.addEventListener("click", activate);
    mobile.addEventListener("change", update);
    let frame = 0;
    const changes = new MutationObserver(() => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (root.isConnected) initialize(root);
      });
    });
    changes.observe(root, { childList: true, subtree: true });
    const dispose = () => {
      observer.disconnect();
      changes.disconnect();
      cancelAnimationFrame(frame);
      mobile.removeEventListener("change", update);
      action.removeEventListener("click", activate);
      instances.delete(root);
    };
    instances.set(root, { bar, form, dispose });
    update();
  };
  const initializeAll = (scope = document) => {
    if (scope.matches?.('product-info[id^="MainProduct-"]')) initialize(scope);
    scope.querySelectorAll('product-info[id^="MainProduct-"]').forEach(initialize);
  };
  window.novaProductExperience = initializeAll;
  initializeAll();
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll('product-info[id^="MainProduct-"]').forEach((root) => instances.get(root)?.dispose());
  });
})();
